import { useEffect, useRef } from 'react'
import { useForm } from 'react-hook-form'
import Drawer from '../../components/common/Drawer'
import Label from '../../components/form/Label'
import Input from '../../components/form/input/InputField'
import { useCompany } from '../../context/CompanyContext'
import toast from 'react-hot-toast'
import { api } from '../../configs/api'
import { useAuth } from '../../context/AuthContext'
import { useNavigate } from 'react-router'
import { useBusiness } from '../../context/BusinessContext'

const CompanyForm = ({
    type,
    open,
    handleClose
}: {
    type: 'create' | 'edit'
    open: boolean
    handleClose: () => void
}) => {
    const { unity } = useAuth()
    const { detail, getCompany } = useCompany()
    const { loadBusiness } = useBusiness()
    const form = useForm({ mode: 'onChange' })
    const formRef = useRef<HTMLFormElement>(null)
    const navigate = useNavigate()

    const handleSave = async (data: any) => {
        if (!unity) return

        if (type === 'edit' && !detail?.company.id) {
            return toast.error('Nenhuma empresa selecionada!')
        }

        try {
            const route = type === 'create' ? `${api}company/create` : `${api}company/update`
            const values = {
                ...data,
                id: type === 'edit' ? detail?.company.id : null,
                unityID: unity.unityID
            }
            const response = await fetch(route, {
                method: 'POST',
                body: JSON.stringify(values)
            })
            const result = await response.json()
            if (!result.success || !result.company.id) return toast.error(result.message || 'Erro ao salvar empresa!')

            getCompany(result.company.id)
            if (type === 'edit') loadBusiness()
            handleClose()
            toast.success(result.message || 'Empresa salva com sucesso!')
            if (type === 'create') navigate(`/empresa/${result.company.id}`)
        } catch (error) {
            console.log(error)
        }
    }

    // Atualiza os valores do formulário quando o contexto mudar
    useEffect(() => {
        if (type === 'edit' && detail) {
            form.reset({
                name: detail.company.name || '',
                email: detail.company.email || '',
                phone: detail.company.phone || ''
            })
        } else if (type === 'create') {
            form.reset({
                name: '',
                email: '',
                phone: ''
            })
        }
    }, [detail])

    return (
        <Drawer
            open={open}
            handleClose={handleClose}
            title={type === 'create' ? 'Adicionar empresa' : 'Editar empresa'}
            handleSave={() => formRef.current?.requestSubmit()}
        >
            <form ref={formRef} onSubmit={form.handleSubmit(handleSave)}>
                <div className='space-y-3'>
                    <div>
                        <Label required>Nome</Label>
                        <Input {...form.register('name', { required: true })} placeholder='Nome' />
                    </div>
                    <div>
                        <Label>E-mail</Label>
                        <Input {...form.register('email')} type='email' placeholder='E-mail' />
                    </div>
                    <div>
                        <Label>Telefone</Label>
                        <Input {...form.register('phone')} placeholder='Telefone' />
                    </div>
                </div>
            </form>
        </Drawer>
    )
}

export default CompanyForm
